let go = window.go;
if (!go){
  go = require('GoJs');
}

module.exports = go;